import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton, SelectFilter } from '@/components';
import { LSE_EVENTS } from '@/constants';
import { useSearchParams } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useMemo } from 'react';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
export default function StakingEngineStakingActivityPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(LSE_EVENTS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.eventType
      }))
    );
    return options;
  }, [filters]);

  const [data, error] = useApi({
    url: `/lsev2/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={tokensMapping('SKY').name}
                address={tokensMapping('SKY').address}
                size="4"
              />
            }>
            <Heading size="1">Staking Engine Activity</Heading>
          </EntityName>
        }>
        <HistoricTabs />
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="3">Events</Heading>
          <SelectFilter
            key="event-filter"
            filterField="eventType"
            options={selectFilterOptions}
            pagination={pagination}
            {...filters}
          />
        </Flex>

        <EventsTable
          pagination={pagination}
          sorting={sorting}
          filters={filters}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
